'use client';

import { Card, CardContent } from '@packages/shared/src/ui/Card/Card';
import Link from 'next/link';
import { useIntl } from 'react-intl';

export type ExtendedRecoCardItemProps = {
  /**
   * The link to the extended view page
   */
  link: string;
};

export const ExtendedRecoCardItem = ({ link }: ExtendedRecoCardItemProps) => {
  const { formatMessage } = useIntl();
  return (
    <Link href={link} className="h-full">
      <Card className="h-full">
        <CardContent className="flex h-full flex-col items-center justify-center">
          <p className="text-center underline">
            {formatMessage({
              id: 'extendedRecoCardItem.title',
              defaultMessage: 'Entdecke mehr interessante Artikel',
            })}
          </p>
        </CardContent>
      </Card>
    </Link>
  );
};
